import {
  getStandardSignatureRect,
  isStandardSignPosition,
} from 'src/app/shared-components/signature-position.util';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { DataTransferService } from '../data-transfer.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { CatEditService } from 'src/app/services/cat-edit.service';
import { MessageService } from 'primeng/api';
import { StorageService } from 'src/app/services/storage.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';
import { ExcelDataValidator } from 'src/app/models/excel-validation-edit';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { single } from 'rxjs';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { OrderService } from 'src/app/services/order.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { WalletService } from 'src/app/services/wallet.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';
import { EstampService } from 'src/app/services/estamp.service';
import { CAT_EXECUTION_UPLOAD_CONSTANTS } from 'src/app/models/cat-execution-upload.constant';
import { StampDenominationService } from 'src/app/services/stamp-denomination.service';

type AOA = any[][];

@Component({
    selector: 'app-upload-document',
    templateUrl: './upload-document.component.html',
    styleUrls: ['./upload-document.component.scss'],
    standalone: false
})
export class UploadDocumentComponent implements OnInit, OnDestroy {
  readonly errorModalColumns: TableColumn[] = [
    {
      field: 'reference_number',
      header: 'Reference Number',
      width: '35%',
      cellStyle: { 'white-space': 'nowrap', 'font-weight': '500' },
    },
    {
      field: 'message',
      header: 'Error Message',
      width: '65%',
      cellStyle: { 'white-space': 'normal', 'word-break': 'break-word', 'line-height': '1.4' },
    },
  ];

  readonly estampErrorColumns: TableColumn[] = [
    { field: 'referance_id', header: 'Reference ID' },
    { field: 'branch_code', header: 'Branch Code' },
    { field: 'first_party_name', header: 'First Party' },
    { field: 'second_party_name', header: 'Second Party' },
    { field: 'stamp_duty_paid_by', header: 'Stamp Duty Paid By' },
    { field: 'stamp_duty_amount', header: 'Stamp Duty Amount' },
    { field: 'description', header: 'Description' },
    { field: 'article_code', header: 'Article Code' },
    { field: 'consideration_amount', header: 'Consideration Amount' },
    { field: 'execution_date', header: 'Execution Date' },
    { field: 'update_by', header: 'Update By' },
  ];

  readonly esignErrorColumns: TableColumn[] = [
    { field: 'referance_id', header: 'Reference ID' },
    { field: 'branch_code', header: 'Branch Code' },
    { field: 'sign_name', header: 'Name' },
    { field: 'sign_email', header: 'Email' },
    { field: 'sign_contact_number', header: 'Contact Number' },
    { field: 'sign_position', header: 'Sign Position' },
    { field: 'method', header: 'Method' },
    { field: 'pages', header: 'Pages' },
    { field: 'user_type', header: 'User Type' },
  ];

  @ViewChild('reviewOrder') reviewOrder: TemplateRef<any>;
  @ViewChild('orderDetails') orderDetails!: OrderConfirmationDetailsComponent;
  branches: any;
  fileName: any = 'Selected File';
  selectedBranch: any;
  productDetails: FormGroup;
  selectedDocumentType = '';
  uploadFile!: File;
  showTemplatePage: boolean = false;
  showUploadPage: boolean = true;
  showUploadButton: boolean = false;
  selectFile: any;
  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;
  @ViewChild('closePaymentPopupBtn') closePaymentPopupBtn!: ElementRef;
  @Input() uploadDocumentsData: any = [];
  @Output() uploadDocsChange: EventEmitter<any> = new EventEmitter<[]>();
  isDocUploaded: boolean = false;
  excelData: any = [];
  keys: any;
  dbColumnsMap: any;
  excelHeaders: string[] = [];   
showColumnInput = false;
selectedColumns: string[] = [];
columnName: string = '';  
  totalExcelRecords: any;
  totalListNumber: any;
  totalRecordsData: any;
  dataUploaded: boolean = false;
  storeImportedFileData: any;
  fileUploaded: any;
  estampHeaders = [
    'referance_id',
    'branch_code',
    'first_party_name',
    'second_party_name',
    'stamp_duty_paid_by',
    'stamp_duty_amount',
    'description',
    'article_code',
    'consideration_amount',
    'execution_date',
    'update_by',
  ];
  bothServiceHeaders = [
    'referance_id',
    'branch_code',
    'first_party_name',
    'second_party_name',
    'stamp_duty_paid_by',
    'stamp_duty_amount',
    'description',
    'Artical_code',
    'consideration_amount',
    'execution_date',
    'sign_name',
    'sign_email',
    'sign_contact_number',
    'sign_position',
    'method',
    'pages',
    'user_type',
  ];
  esignHeaders = [
    'referance_id',
    'branch_code',
    'sign_name',
    'sign_email',
    'sign_contact_number',
    'sign_position',
    'method',
    'pages',
    'user_type',
  ];
  data: AOA = [
    [1, 2],
    [3, 4],
  ];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  coloumData: any = [];
  headers: any;
  selectedValue: any;
  showFileName: boolean = false;
  convertedData: any = [];
  stampValidation: any = [];
  eSignDetails: any = {};
  eStampDetails: any = {};
  partyDeatils: any = [];
  withnessDetails: any = [];
  uploadDetails: any = {};
  templateData: any = [];
  showEsign: boolean = false;
  showEstamp: boolean = false;
  showBoth: boolean = false;
  today = new Date();
  recieveTemplateData: any = [];
  alltemplateDetails: any = [];
  addTemplateFields: any = [];
  states: any;
  branchId: any;
  placeOrderData: any;
  chooseFile: boolean = false;
  // total_order = 0;
  total_amount = 0;
  issueList = [];
  selectedFile: any;
  fileApproved = false;
  excelRowsObjArr: any[];
  branchList: any[];
  branchCodeList: any = [];
  userName: string;
  isFileUpload: boolean = false;
  rowsWithIssues: any[];
  option: string = '';
  showbulk_esign: boolean = false;
  showbulk_estamp: boolean = false;
  validationErrorData: any = [];
  errorBracnhList: any[];
  serviceType: string = 'E-Sign';
  templateValues: any;
  rowNumberIssue: any = [];
  rowstoDisplay: any = [];
  currentDate = new Date();
  jsonData: any[] = [];

  isDragging = false;

  excelALTopHeader: string[] = [
    'Token_Dlp_Id',
    'Token_Date_Of_Disbursment',
    'Token_Name',
    'Token_App_Id',
    'Token_Agreement_No',
    'Token_Date_And_Time',
    'Token_Loan_Amount',
    'Token_Loan_Amount_In_Words',
    'Token_Customer_Id',
    'Token_Submission_Date',
    'Token_Ip_Address',
    'Token_Address_1',
    'Token_Address_2',
    'Token_Address_3',
    'Token_City_Words',
    'Token_State_Name',
    'Token_Pin',
    'Token_Parent_Lan',
    'Token_Tenure',
    'Token_Eff_Rate',
    'Token_Pf',
    'Token_Emi',
    'Token_Emi_Words',
    'Token_Disbursed_Amount',
    'Token_Parent_Loan_Amount',
    'Token_Parent_Amount_Words',
    'Token_Date_Of_Agreement_Of_Parent_Loan',
    'Loan_Agreement_No',
    'Document_Title',
    'Document_Description',
    'First_Party',
    'Second_Party_First_Name',
    'Second_Party_Last_Name',
    'Stamp_Type',
    'Stamp_State',
    'Stamp_Amount',
    'Document_Category',
    'Paid_By',
    'Branch',
    'Application_Number',
    'Consideration_Amount',
    'Stamp_Request',
  ];
  excelBLoanHeader: string[] = [
    'Token_Dlp_Id',
    'Token_Date_Of_Disbursment',
    'Token_Name',
    'Token_Date_And_Time',
    'Token_Loan_Amount',
    'Token_Loan_Amount_In_Words',
    'Token_Source',
    'Token_Customer_Id',
    'Token_Ip_Address',
    'Token_App_Id',
    'Token_Pan',
    'Token_Mobileno',
    'Token_Address_One',
    'Token_Address_Two',
    'Token_Address_Three',
    'Token_City_Words',
    'Token_State_Name',
    'Token_Pin',
    'Token_Tenure',
    'Token_Effrate',
    'Token_Calculate_Pf',
    'Token_Emi_Words',
    'Token_Emi',
    'Token_Disbursedamount',
    'Token_Mapped_Acc',
    'Token_Stamp_Duty',
    'Loan_Agreement_No',
    'Document_Title',
    'Document_Description',
    'First_Party',
    'Second_Party_First_Name',
    'Second_Party_Last_Name',
    'Stamp_Type',
    'Stamp_State',
    'Stamp_Amount',
    'Document_Category',
    'Paid_By',
    'Branch',
    'Application_Number',
    'Consideration_Amount',
    'Stamp_Request',
  ];
  ElectronicPostionDetails = [
    { position: 'BOTTOM_LEFT', loc: { x1: 5, y1: 740, x2: 165, y2: 830 } },
    {
      position: 'BOTTOM_LEFT_MIDDLE',
      loc: { x1: 115, y1: 740, x2: 195, y2: 830 },
    },
    { position: 'BOTTOM_CENTRE', loc: { x1: 225, y1: 740, x2: 375, y2: 830 } },
    { position: 'BOTTOM_CENTER', loc: { x1: 225, y1: 740, x2: 375, y2: 830 } },
    {
      position: 'BOTTOM_RIGHT_MIDDLE',
      loc: { x1: 395, y1: 740, x2: 490, y2: 830 },
    },
    { position: 'BOTTOM_RIGHT', loc: { x1: 460, y1: 740, x2: 620, y2: 830 } },
    { position: 'MIDDLE_LEFT', loc: { x1: 5, y1: 425, x2: 165, y2: 505 } },
    { position: 'MIDDLE_RIGHT', loc: { x1: 462, y1: 425, x2: 622, y2: 505 } },
    { position: 'TOP_LEFT', loc: { x1: 5, y1: 50, x2: 165, y2: 150 } },
    { position: 'TOP_CENTRE', loc: { x1: 225, y1: 50, x2: 375, y2: 150 } },
    { position: 'TOP_CENTER', loc: { x1: 225, y1: 50, x2: 375, y2: 150 } },
    { position: 'TOP_RIGHT', loc: { x1: 460, y1: 50, x2: 620, y2: 150 } },
    { position: 'BAILEE_1', loc: { x1: 370, y1: 70, x2: 530, y2: 170 } },
    { position: 'CHCOMPANY', loc: { x1: 405, y1: 195, x2: 480, y2: 245 } },
    { position: 'PNEUMATIC', loc: { x1: 135, y1: 195, x2: 215, y2: 245 } },
  ];
  AadhaarPostionDetails = [
    { position: 'BOTTOM_LEFT', loc: { x1: 5, y1: 5, x2: 124, y2: 55 } },
    {
      position: 'BOTTOM_LEFT_MIDDLE',
      loc: { x1: 166, y1: 48, x2: 210, y2: 98 },
    },
    { position: 'BOTTOM_CENTRE', loc: { x1: 238, y1: 5, x2: 357, y2: 55 } },
    { position: 'BOTTOM_CENTER', loc: { x1: 238, y1: 5, x2: 357, y2: 55 } },
    {
      position: 'BOTTOM_RIGHT_MIDDLE',
      loc: { x1: 420, y1: 48, x2: 445, y2: 98 },
    },
    { position: 'BOTTOM_RIGHT', loc: { x1: 471, y1: 5, x2: 590, y2: 55 } },
    { position: 'MIDDLE_RIGHT', loc: { x1: 471, y1: 396, x2: 590, y2: 446 } },
    { position: 'MIDDLE_LEFT', loc: { x1: 5, y1: 396, x2: 124, y2: 446 } },
    { position: 'TOP_LEFT', loc: { x1: 5, y1: 787, x2: 124, y2: 837 } },
    { position: 'TOP_CENTRE', loc: { x1: 238, y1: 787, x2: 357, y2: 837 } },
    { position: 'TOP_CENTER', loc: { x1: 238, y1: 787, x2: 357, y2: 837 } },
    { position: 'TOP_RIGHT', loc: { x1: 471, y1: 787, x2: 590, y2: 837 } },
    { position: 'BAILEE_1', loc: { x1: 370, y1: 70, x2: 530, y2: 170 } },
    { position: 'CHCOMPANY', loc: { x1: 405, y1: 195, x2: 480, y2: 245 } },
    { position: 'PNEUMATIC', loc: { x1: 135, y1: 195, x2: 215, y2: 245 } },
    {
      position: 'ATLAS_1_ABOVE',
      loc: {
        x1: 274,
        x2: 349,
        y1: 278,
        y2: 323,
      },
    },
    {
      position: 'ATLAS_1_BELOW',
      loc: {
        x1: 282,
        x2: 357,
        y1: 354,
        y2: 399,
      },
    },
    {
      position: 'ATLAS_2_ABOVE',
      loc: {
        x1: 221,
        x2: 296,
        y1: 234,
        y2: 279,
      },
    },
    {
      position: 'ATLAS_2_BELOW',
      loc: {
        x1: 336,
        x2: 411,
        y1: 334,
        y2: 379,
      },
    },
    {
      position: 'ATLAS_3',
      loc: {
        x1: 298,
        x2: 373,
        y1: 453,
        y2: 498,
      },
    },
  ];

  positionData: any;
  updateByStamp: any = [];
  userBranchList: any = [];
  branchCodeError: any = [];
  accountid: string;
  templateId: any;
  customTemplateFields: any = [];
  reviewDetails: FormGroup;
  reviewEmail: FormArray;
  validEmail: any;
  submitted: boolean = false;
  order_reviewer: any;
  userData: any;
  selectedReviewer: any;
  base64File: string;
  otp_validation: boolean;
  excelDuplicate: any = [];
  emailDuplicate: any = [];
  userId: any;
  userProfileData: any;
  electronicPrice: number;
  dscPrice: number;
  aadhaarPrice: number;
  stampPrice: number;
  total_order = 0;
  totalStampAmountForPopup = 0;
  totalStampAmount = 0;
  totalPayableAmount = 0;
  aadhaarCount = 0;
  electronicCount = 0;
  dscCount = 0;
  stampCount = 0;
  totalConvFee = 0;
  GSTOnTotalBill = 0;
  virtualAccountNo: string;
  is_wallet: boolean = false;
  walletBalance: any;
  canWalletPayment: boolean = false;
  accountId: any;
  billingType: any;
  showProcessTypeDropdown: boolean = false;
  selectedStampProcessType: string =
    CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
  processTypeOptions: { label: string; value: string }[] = [];
  showErrorModal = false;
  excelDownloadLoading = false;
  errorModalData: {
  order_id?: number;
  reference_id?: string;
  errors_message_code?: Array<{
    error_code: string;
    reference_number: string;
    message: string;
  }>;
  } | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private orderService: OrderService,
    private router: Router,
    private userDashboardService: UserDashboardService,
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig,
    private dataService: DataTransferService,
    private catEditService: CatEditService,
    private messageService: MessageService,
    private catUploadService: CatUploadService,
    private confirmationService: ConfirmationService,
    private primeng: PrimeNG,
    private storageService: StorageService,
    private userManagementService: UserManagementService,
    private cdr: ChangeDetectorRef,
    private walletService: WalletService,
    private estampService: EstampService,
    private stampDenominationService: StampDenominationService
  ) {
    this.otp_validation = this.storageService.getOtpValidation() ? true : false;
    this.userId = this.storageService.getUserID();
    if (this.userId) {
      this.editUserDetails(this.userId);
    }
    this.reviewDetails = this.formBuilder.group({
      reviewEmail: this.formBuilder.array([]),
      reviewer: [null],
    });
    this.productDetails = this.formBuilder.group({
      branchName: ['Selected Branch', [Validators.required]],
    });
    //this.selectedValue = this.cookieService.get('BranchName')
    this.selectedBranch = this.storageService.getBranch() || null;
    this.productDetails.controls['branchName'].setValue(
      this.selectedBranch.name
    );
    this.storageService.branchChange.subscribe((branch: any) => {
      this.selectedBranch = branch;
      this.productDetails.controls['branchName'].setValue(branch.name);
    });

    this.userName = this.storageService.getUser() || null;
    this.accountid = this.storageService.getAccountId() || null;
    this.order_reviewer = this.storageService.getOrderReviewConsent() || null;
    this.virtualAccountNo = this.storageService.getVirtualAccountNumber();
    this.is_wallet = this.storageService.getIsWallet();
    this.accountId = this.storageService.getAccountId();
  }

  ngOnChanges(): void {
    let organization_id = this.storageService.getOrganizationId() || null;
    this.catUploadService
      .getPricingDetails(organization_id)
      .subscribe((res) => {
        this.electronicPrice = res.content.esign.electronic;
        this.dscPrice = res.content.esign.dsc;
        this.aadhaarPrice = res.content.esign.aadhaar;
        this.stampPrice = res.content.estamp;
        this.billingType = res.content.billing;
      });
  }

  ngOnDestroy(): void {
    console.log('Destroying the component');
  }

  ngOnInit(): void {
    this.primeng.ripple.set(true);
    this.showUploadButton = true;
    this.alltemplateDetails = this.dataService.getData();
    if (this.alltemplateDetails != undefined) {
      this.recieveTemplateData = this.dataService.getData().fileds;
      this.templateId = this.dataService.getData().id;

      this.getClientFieldDetails(this.accountid, this.templateId);
      this.addTemplateFields = [];
      this.recieveTemplateData.forEach((field: any) => {
        this.addTemplateFields.push(field.id_attribute);
      });
      console.log(this.alltemplateDetails);
    } else {
      this.router.navigate(['doqfy/cat-edit/form']);
    }

    this.getBranchId();
    if (this.is_wallet) {
      this.getRealWalletBalance(this.virtualAccountNo);
    } else {
      this.getDummyWalletBalance(this.accountId);
    }
  }

  get isPrepaid(): boolean {
    return (
      this.is_wallet &&
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
    );
  }

  get isPostpaid(): boolean {
    return (
      this.is_wallet &&
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_POSTPAID
    );
  }

  getClientFieldDetails(accountid: any, templateid: any) {
    let data = {
      account_id: accountid,
      template_id: templateid,
    };

    this.catEditService.getCustomTemplateFields(data).subscribe((res) => {
      this.customTemplateFields = res['content'];
    });
  }
  getBranchId() {
    this.userDashboardService.getBranchList().subscribe((res: any) => {
      this.states = res['content'];
      this.states.forEach((branch: { name: any; id: any }) => {
        if (branch.id === this.selectedBranch.id) {
          this.branchId = branch.id;
        }
      });
    });
    this.userDashboardService.getBranchList().subscribe((res: any) => {
      this.branchList = res['content'];

      this.branchList = this.branchList.filter(
        (element) => element.is_active === true
      );
      this.branchList.forEach((element) => {
        this.userBranchList.push(element.branch_code);
      });
    });
  }

  editUserDetails(id: any) {
    this.userManagementService.getUsersDetailsById(id).subscribe((res: any) => {
      this.userProfileData = res['content'][0];

      if (this.userProfileData.id === Number(id)) {
        this.branches = this.userProfileData.branch_codes;
      }
    });
  }

  excelOption(value: any) {
    this.uploadDocumentsData = this.productDetails.value;
    this.uploadDocumentsData.sampleExcel = value;
    this.serviceType = value;
    this.cancelUpload();

      this.showProcessTypeDropdown =
        value === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP ||
        value === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH;

      if (this.showProcessTypeDropdown) {
        this.showUploadButton = false;
        this.loadProcessTypeOptions();
      } else {
        this.showUploadButton = true;
      }
  }

  loadProcessTypeOptions(): void {
    const state = this.storageService.getState();
    if (!state?.state_code) {
      // No state yet — show all options, default to Inventory
      this.selectedStampProcessType = CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
      this.processTypeOptions = [
        { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
        { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
        { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
      ];
      this.cdr.detectChanges();
      return;
    }

    this.estampService.getStateDenomination({ state_code: state.state_code }).subscribe({
      next: (resp: any) => {
        if (resp?.status && resp['content']?.length > 0) {
          const stateInfo = resp['content'][0];
          const options: { label: string; value: string }[] = [];

          if (stateInfo.pre_estamp === true || stateInfo.traditional === true) {
            options.push({ label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT });
          }
          if (stateInfo.estamp === true) {
            options.push({ label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY });
          }
          if (stateInfo.esbtr === true) {
            options.push({ label: 'ESBTR', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR });
          }

          const finalOptions = options.length > 0 ? options : [
            { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
            { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
            { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
          ];

          // Set value BEFORE options so PrimeNG sees a matching value when options arrive
          const hasOnTheFly = finalOptions.some(o => o.value === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY);
          this.selectedStampProcessType = hasOnTheFly
            ? CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY
            : CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
          this.processTypeOptions = finalOptions;
          this.cdr.detectChanges();
        } else {
          // No data from API — show all 3, default to Inventory
          this.selectedStampProcessType = CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
          this.processTypeOptions = [
            { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
            { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
            { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
          ];
          this.cdr.detectChanges();
        }
      },
      error: () => {
        // On error — show all 3, default to Inventory
        this.selectedStampProcessType = CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
        this.processTypeOptions = [
          { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
          { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
          { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
        ];
        this.cdr.detectChanges();
      }
    });
  }

  openViewPopUp(content: TemplateRef<any>) {
    this.modalConfig.backdrop = 'static';
    this.modalService.open(content, {
      size: 'xl',
      centered: true,
      scrollable: true,
      modalDialogClass: 'largeTableModal',
    });
  }

  onEditExcelDataseve(event: any) {
    this.convertedData = [...event];
    this.getOrderObjectswithOut(this.convertedData);
  }

  openUploadDocPopup() {
    this.fileName = 'Selected File';
    this.showFileName = false;
    this.isFileUpload = false;
    this.showbulk_esign = false;
    this.showbulk_estamp = false;
    this.convertedData = [];
    this.issueList = [];
    this.clearFile();
    this.excelHeaders = [];      
    this.selectedColumns = [];
  }

  onSendProductDetails() {
    this.uploadDocumentsData = this.productDetails.value;
    this.uploadDocumentsData.option = this.option;
    setTimeout(() => {
      this.uploadDocsChange.emit(this.uploadDocumentsData);
    }, 1000);
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  cancelUpload() {
      this.showColumnInput = false;
    this.showFileName = false;
    this.isFileUpload = false;

    this.closeUploadPopupBtn.nativeElement.click();
    this.fileName = 'Selected File';

    this.issueList = [];
    this.rowsWithIssues = [];
    this.clearFile();
      this.columnName = '';
  }

  uploadSelFile() {
     if (this.showColumnInput) {
    if (!this.showFileName) {
      this.chooseFile = true;
    } else {
      this.chooseFile = false;
      this.closeUploadPopupBtn.nativeElement.click();
      this.sendCsvToBackend();
    }
    return; 
  }
    
    if (
      this.emailDuplicate.length > 0 ||
      this.excelDuplicate.length > 0 ||
      this.issueList.length > 0 ||
      this.branchCodeError.length > 0 ||
      this.updateByStamp.length > 0
    ) {
      this.showFileName = false;
      this.closeUploadPopupBtn.nativeElement.click();
      this.fileName = 'Selected File';
      this.isFileUpload = false;
      this.issueList = [];
      this.rowsWithIssues = [];
      this.clearFile();
    } else {
      if (!this.showFileName) {
        this.chooseFile = true;
      } else {
        this.chooseFile = false;
        this.isDocUploaded = true;
        this.isFileUpload = true;
        this.closeUploadPopupBtn.nativeElement.click();
      }
    }
  }

  removeFileName() {
    this.showFileName = false;
    this.closeUploadPopupBtn.nativeElement.click();
    this.fileName = 'Selected File';
    this.isFileUpload = false;
    this.issueList = [];
    this.rowsWithIssues = [];
    this.clearFile();
  }

  normalizeString(input) {
    return input ? input.toString().trim().toLowerCase() : '';
  }

  onFileChange(evt: any) {
    this.issueList = [];
    this.updateByStamp = [];
    this.excelDuplicate = [];
    this.emailDuplicate = [];
    this.isFileUpload = true;
    let files = evt.target.files;
    this.selectedFile = files[0];
    this.fileName = files[0].name;

    // Debugging: Check the file name before the replace operation

    // Remove the "(3)" or similar pattern from the file name
    this.fileName = this.fileName.replace(/\s*\(\d+\)/, '');
    // Debugging: Check the file name after the replace operation

    if (this.fileName) {
      //File Validation
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 10) {
        //alert('File should be less than 10MB in size');
        this.messageService.add({
          severity: 'warn',
          detail: 'File should be less than 10MB in size',
        });
        const inputElement = <HTMLInputElement>(
          document.getElementById('upload_file')
        );
        inputElement.value = null;
        return;
      }

      let splitName = files[0].name.split('.');
      if (
        splitName[splitName.length - 1] !== 'xlsx' &&
        splitName[splitName.length - 1] !== 'xls'&&
              splitName[splitName.length - 1] !== 'csv'
      ) {
        //alert('Not a valid Excel file. Please upload another one');
        this.messageService.add({
          severity: 'warn',
          detail: 'Not a valid Excel file. Please upload another one',
        });
        const inputElement = <HTMLInputElement>(
          document.getElementById('upload_file')
        );
        inputElement.value = null;
        return;
      } else if (splitName.length > 2) {
        //alert('File name should have only single extension');
        this.messageService.add({
          severity: 'warn',
          detail: 'File name should have only single extension',
        });
        const inputElement = <HTMLInputElement>(
          document.getElementById('upload_file')
        );
        inputElement.value = null;
        return;
      }

      this.showFileName = true;
      this.chooseFile = false;

      /* wire up file reader */
      const target: DataTransfer = <DataTransfer>evt.target;
      if (target.files.length !== 1)
        throw new Error('Cannot use multiple files');
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        //----------------------------Base 64 ----------------------------------//
        this.base64File = btoa(e.target.result);

        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, {
          type: 'binary',
          cellDates: true,
        });

          if (this.showColumnInput) {
          const use_bulk_upload_raw_temp = this.alltemplateDetails?.use_bulk_upload_raw
            ? false
            : true;
          const headerSet = new Set<string>();
 
          wb.SheetNames.forEach((sheetName) => {
            const sheet = wb.Sheets[sheetName];
            const sheetRows: any[][] = XLSX.utils.sheet_to_json(sheet, {
              header: 1,
              raw: use_bulk_upload_raw_temp,
            });
            const sheetHeaders = sheetRows[0] as any[];
            if (sheetHeaders) {
              sheetHeaders.forEach((h) => {
                if (h !== undefined && h !== null && h.toString().trim() !== '') {
                  headerSet.add(h.toString());
                }
              });
            }
          });

          
          const allXlsxHeaders = Array.from(headerSet);
          if (this.addTemplateFields && this.addTemplateFields.length > 0) {
            this.excelHeaders = allXlsxHeaders.filter(h =>
              this.addTemplateFields.includes(h)
            );
           
            if (this.excelHeaders.length === 0) {
              this.excelHeaders = [...this.addTemplateFields];
            }
          } else {
            this.excelHeaders = allXlsxHeaders;
          }

          this.selectedColumns = [];
          this.cdr.detectChanges();
          return;
        }
           
        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        var validation = this.alltemplateDetails?.validation;

        /* save data */
        var use_bulk_upload_raw = this.alltemplateDetails?.use_bulk_upload_raw
          ? false
          : true;
        this.jsonData = XLSX.utils.sheet_to_json(ws, {
          header: 1,
          raw: use_bulk_upload_raw,
        });
        this.excelRowsObjArr = XLSX.utils.sheet_to_json(wb.Sheets[wsname]);

        this.jsonData.forEach((row, index) => {
          for (const key in row) {
            if (key !== 'execution_date') {
              let value = row[key];

              // Case 1: actual Date object
              if (value instanceof Date) {
                value = moment(value).add(1, 'days').toDate();
                row[key] = value.toLocaleDateString('en-GB');
              }

              // Case 2: string that looks like a date
              else if (
                typeof value === 'string' &&
                moment(value, ['M/D/YY', 'MM/DD/YYYY'], true).isValid()
              ) {
                row[key] = moment(value, ['M/D/YY', 'MM/DD/YYYY']).format(
                  'DD/MM/YYYY'
                );
              }
            }
          }
        });

        let originalHeaders: string[] = this.jsonData.shift() as string[];

        if (this.showColumnInput) {
        
          if (this.addTemplateFields && this.addTemplateFields.length > 0) {
            const filtered = originalHeaders.filter(h =>
              this.addTemplateFields.includes(h)
            );
            this.excelHeaders = filtered.length > 0 ? filtered : [...this.addTemplateFields];
          } else {
            this.excelHeaders = [...originalHeaders];
          }
          this.selectedColumns = [];
          this.cdr.detectChanges();
          return;
        }

        this.excelHeaders = [...originalHeaders];
        this.selectedColumns = [];
        let newHeaders: string[] = [...originalHeaders]; // Create a copy of the original headers

        if (this.customTemplateFields.length !== 0) {
          this.customTemplateFields.forEach((field) => {
            newHeaders.push(field.template_field); // Add a new header with template_field value
          });
        }

        if (
          this.customTemplateFields.length !== 0 &&
          this.customTemplateFields[0]?.document_template_name === 'AL Top-up'
        ) {
          for (let i = 0; i < this.excelALTopHeader.length; i++) {
            const header = this.excelALTopHeader[i];
            if (!originalHeaders.includes(header)) {
              const mismatchedHeader = `Uploaded Excel: ${header}, Excel AL Top Header: ${this.excelALTopHeader[i]}`;
              const data = {
                rowNumber: `Column - ${i + 1}`,
                error: `The header value is mismatched or Missing: ${mismatchedHeader}`,
              };
              this.excelDuplicate.push(data);
            }
          }
        }

        if (
          this.customTemplateFields.length !== 0 &&
          this.customTemplateFields[0]?.document_template_name ===
            'Bussiness Loan'
        ) {
          for (let i = 0; i < this.excelBLoanHeader.length; i++) {
            const header = this.excelBLoanHeader[i];
            if (!originalHeaders.includes(header)) {
              const mismatchedHeader = `Uploaded Excel: ${header}, Excel Business Loan Header: ${this.excelBLoanHeader[i]}`;
              const data = {
                rowNumber: `Column - ${i + 1}`,
                error: `The header value is mismatched or Missing : ${mismatchedHeader}`,
              };
              this.excelDuplicate.push(data);
            }
          }
        }

        this.convertedData = this.jsonData.map((row) => {
          const rowData: any = {};

          // Map data from originalHeaders
          originalHeaders.forEach((header, index) => {
            rowData[header] = row[index] !== undefined ? row[index] : '';
          });

          // Map additional data from customTemplateFields
          const fieldMap = new Map();
          this.customTemplateFields.forEach((field) => {
            const templateField = field.template_field;
            const clientFieldValue =
              row[originalHeaders.indexOf(field.client_field)] || '';

            if (!fieldMap.has(templateField)) {
              fieldMap.set(templateField, clientFieldValue);
            } else {
              // If template_field already exists, concatenate values
              fieldMap.set(
                templateField,
                `${fieldMap.get(templateField)} ${clientFieldValue}`
              );
            }
          });

          // Assign aggregated values to the rowData
          fieldMap.forEach((value, key) => {
            rowData[key] = value;
          });

          // Remove properties with empty values
          Object.keys(rowData).forEach(
            (key) => rowData[key] === '' && delete rowData[key]
          );

          return rowData;
        });

        this.excelDuplicate = [];

        this.convertedData.forEach((dataRow, rowIndex) => {
          this.recieveTemplateData.forEach((field) => {
            const key = field.id_attribute;
            const predefinedValue = field.validators?.predefined_value;
            const isRequired = field.validators?.required === true;

            if (key in dataRow) {
              const value = dataRow[key];

              // Check for null or whitespace ONLY if field is required
              // Allow 0 as a valid value
              if (
                isRequired &&
                (value === undefined ||
                  value === null ||
                  (typeof value === 'string' && value.trim() === ''))
              ) {
                this.excelDuplicate.push({
                  rowNumber: `Row - ${rowIndex + 2}`,
                  error: `Value for header '${key}' is undefined, empty, or contains only spaces.`,
                });
              }

              // Only validate predefined_value if it exists and has a value
              if (
                predefinedValue !== null &&
                predefinedValue !== undefined &&
                value !== undefined &&
                value !== null &&
                value !== ''
              ) {
                const normalizedValue = this.normalizeString(value);
                const normalizedPredefined =
                  this.normalizeString(predefinedValue);

                if (normalizedValue !== normalizedPredefined) {
                  this.excelDuplicate.push({
                    rowNumber: `Row - ${rowIndex + 2}`,
                    error: `Value for '${key}' does not match predefined value (case-insensitive). Expected: '${predefinedValue}', Found: '${value}'.`,
                  });
                }
              }
            }
          });
        });

        // ------------------ ebstr amount Validation -----------------------//

        if (validation?.esbtr && originalHeaders.includes('esbtr_amount')) {
          let allowedKeys = validation?.esbtr?.allowedKeys || [];
          let expectedSumKey = validation?.esbtr?.expectedValue || '';
          this.convertedData.forEach((data, index) => {
            let total = 0;
            allowedKeys.forEach((key: string) => {
              let value = Number(data[key]) || 0;
              total += value;
            });

            if (expectedSumKey && Number(data[expectedSumKey]) !== total) {
              console.log('data[expectedSumKey]', data[expectedSumKey]);
              this.excelDuplicate.push({
                rowNumber: `Row - ${index + 2}`,
                error: `Sum of allowed keys does not match expected value for '${expectedSumKey}'. Expected: ${
                  data[expectedSumKey]
                }, Found: ${total}, Difference: ${
                  Number(data[expectedSumKey]) - total
                }.`,
              });
            }
          });
        }

        //--------------------------------------Branch Code -------------------------------------------------//

        this.convertedData.forEach((data, index) => {
          if (data.branch_code && !this.branches.includes(data.branch_code)) {
            const rowData = {
              rowNumber: index + 2,
              error: `Branch Code ${data.branch_code} is not Assigned to the User . `,
            };
            this.excelDuplicate.push(rowData);
          }
        });

        //------------------------------------------------------------------------------------------------//

        //-------------------------------------------------------------------------------------------------//
        if (
          this.serviceType ===
          CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
        ) {
          function isNullOrWhitespace(value) {
            if (typeof value === 'number') {
              return false;
            } else {
              if (value) {
                value = value.toString();
              }
              return (
                value === undefined || value === null || value.trim() === ''
              );
            }
          }

          this.convertedData.forEach((data, index) => {
            this.recieveTemplateData.forEach((field) => {
              const header = field.id_attribute;
              const isRequired = field.validators?.required === true;

              if (isRequired && isNullOrWhitespace(data[header])) {
                const errorData = {
                  rowNumber: `Row - ${index + 2}`,
                  error: `Value for header '${header}' is undefined, empty, or contains only spaces.`,
                };
                this.excelDuplicate.push(errorData);
              }
            });
          });
        }

        //-------------------------------------------------------------------------------------------------------//

        this.convertedData.forEach((obj) => {
          // Iterate over the object properties
          for (const prop in obj) {
            if (obj[prop] === '') {
              // Remove the property with empty value
              delete obj[prop];
            }
          }
        });

        //-------------------------For Axis Bank TO fine Duplicate Values for Token_App_Id and Token_Parent_Lan  ----------------------------------------------------//

        if (
          this.customTemplateFields.length !== 0 &&
          this.customTemplateFields[0]?.document_template_name === 'AL Top-up'
        ) {
          const uniqueTokenAppIds = new Set();
          const uniqueTokenParentLans = new Set();
          const uniqueLoanAgreementNo = new Set();
          const uniqueTokenCustomerId = new Set();
          for (let i = 0; i < this.convertedData.length; i++) {
            const data = this.convertedData[i];
            if (
              data.Token_App_Id ||
              data.Token_Parent_Lan ||
              data.Loan_Agreement_No
            ) {
              const tokenAppId = String(data.Token_App_Id);
              const tokenParentLan = String(data.Token_Parent_Lan);
              const loanAgreementNo = String(data.Loan_Agreement_No);
              const tokenCustomerId = String(data.Token_Customer_Id);

              //----------- Check Length of Token Customer Id -------------------//

              if (tokenCustomerId.length != 9) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Token_Customer_Id should be 9 length: ${tokenCustomerId}`,
                };
                this.excelDuplicate.push(data);
              }
              if (tokenAppId.length != 8) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Token_App_Id should be 8 length: ${tokenAppId}`,
                };
                this.excelDuplicate.push(data);
              }
              if (loanAgreementNo.length != 15) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Loan_Agreement_No should be 15 length: ${loanAgreementNo}`,
                };
                this.excelDuplicate.push(data);
              }

              // Check for duplicate Loan Agreement No

              if (uniqueLoanAgreementNo.has(loanAgreementNo)) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Duplicate Loan_Agreement_No found: ${loanAgreementNo}`,
                };
                this.excelDuplicate.push(data);
              } else {
                uniqueLoanAgreementNo.add(loanAgreementNo);
              }

              // Check for duplicate Token_App_Id
              if (uniqueTokenAppIds.has(tokenAppId)) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Duplicate Token_App_Id found: ${tokenAppId}`,
                };
                this.excelDuplicate.push(data);
              } else {
                uniqueTokenAppIds.add(tokenAppId);
              }

              // Check for duplicate Token_Parent_Lan
              if (uniqueTokenParentLans.has(tokenParentLan)) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Duplicate Token_Parent_Lan found: ${tokenParentLan}`,
                };
                this.excelDuplicate.push(data);
              } else {
                uniqueTokenParentLans.add(tokenParentLan);
              }
            }
          }
        }

        if (
          this.customTemplateFields.length !== 0 &&
          this.customTemplateFields[0]?.document_template_name ===
            'Bussiness Loan'
        ) {
          const uniqueTokenAppIds = new Set();
          const uniqueLoanAgreementNo = new Set();
          for (let i = 0; i < this.convertedData.length; i++) {
            const data = this.convertedData[i];
            if (data.Token_App_Id || data.Loan_Agreement_No) {
              const tokenAppId = String(data.Token_App_Id);
              const loanAgreementNo = String(data.Loan_Agreement_No);
              const tokenCustomerId = String(data.Token_Customer_Id);

              if (tokenCustomerId.length != 9) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Token_Customer_Id should be 9 length: ${tokenCustomerId}`,
                };
                this.excelDuplicate.push(data);
              }
              if (tokenAppId.length != 8) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Token_App_Id should be 8 length: ${tokenAppId}`,
                };
                this.excelDuplicate.push(data);
              }
              if (loanAgreementNo.length != 15) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Loan_Agreement_No should be 15 length: ${loanAgreementNo}`,
                };
                this.excelDuplicate.push(data);
              }

              // Check for duplicate Loan Agreement No

              if (uniqueLoanAgreementNo.has(loanAgreementNo)) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Duplicate Loan_Agreement_No found: ${loanAgreementNo}`,
                };
                this.excelDuplicate.push(data);
              } else {
                uniqueLoanAgreementNo.add(loanAgreementNo);
              }

              // Check for duplicate Token_App_Id
              if (uniqueTokenAppIds.has(tokenAppId)) {
                const data = {
                  rowNumber: `Row - ${i + 2}`,
                  error: `Duplicate Token_App_Id found: ${tokenAppId}`,
                };
                this.excelDuplicate.push(data);
              } else {
                uniqueTokenAppIds.add(tokenAppId);
              }
            }
          }
        }

        //---------------------------------------------------------------------------------------------------------------------------------------------------------------//

        this.convertedData = this.convertedData.filter(
          (obj) => Object.keys(obj).length !== 0
        );
        // **NEW VALIDATION: Check for decimal values in consideration_amount BEFORE parseInt conversion**
        this.convertedData.forEach((item, index) => {
          if (
            item.consideration_amount !== undefined &&
            item.consideration_amount !== null &&
            item.consideration_amount !== ''
          ) {
            const amount = item.consideration_amount.toString();

            // Check if the value contains a decimal point or is a decimal number
            if (amount.includes('.') || !Number.isInteger(Number(amount))) {
              const data = {
                rowNumber: `Row - ${index + 2}`,
                error: `Consideration Amount must be a whole number (no decimals allowed). Found: ${item.consideration_amount}`,
              };
              this.excelDuplicate.push(data);
            }
          }
        });

        this.convertedData.forEach((item, index) => {
          if (item.update_by) {
            const updateByLowerCase = item.update_by.toLowerCase();
            if (updateByLowerCase.startsWith('t')) {
              const data = { rowNumber: index + 2, type: 'Traditional' };
              this.stampValidation.push(data);
            }
          }
          if (item.consideration_amount) {
            item.consideration_amount = parseInt(item.consideration_amount);
          }
          if (item.stamp_duty_amount) {
            item.stamp_duty_amount = parseInt(item.stamp_duty_amount);
          }
          if (item.stamp_duty_paid_by) {
            if (
              item.stamp_duty_paid_by !== 'first_party_name' &&
              item.stamp_duty_paid_by !== 'second_party_name'
            ) {
              item.stamp_duty_paid_by = 'first_party_name';
            }
          }
          if (this.customTemplateFields.length != 0) {
            this.customTemplateFields.forEach((field) => {
              if (field.template_field != 'execution_date') {
                if (!item.execution_date) {
                  item.execution_date = moment(this.currentDate).format(
                    'DD-MM-YYYY'
                  );
                }
              }
            });
          }
          // if (item.update_by) {
          //   const updateByLowerCase = item.update_by.toLowerCase();
          //   if (updateByLowerCase === 'estamp' || updateByLowerCase === 'traditional') {
          //     const data = { rowNumber: index + 2, type: 'Traditional' };
          //     this.stampValidation.push(data);
          //   }
          //   else {
          //     const data = { rowNumber: index + 2, error: 'Invalid update_by value. Please use either "Estamp" or "Traditional".' };
          //     this.updateByStamp.push(data)
          //   }
          // }
          // if (item.branch_code) {
          //   if (!this.userBranchList.includes(item.branch_code)) {
          //     const data = { rowNumber: index + 2, error: 'Invalid Branch Code value:' + item.branch_code };
          //     this.branchCodeError.push(data)
          //   }
          // }
        });

        //---------------------------Duplicate referance Id & special char validation ----------------------------------------//
        const uniqueReferanceId = new Set();
        const invalidRefIdPattern = /[^a-zA-Z0-9_ ]/;
        for (let i = 0; i < this.convertedData.length; i++) {
          const data = this.convertedData[i];
          if (data.referance_id) {
            const referanceId = data.referance_id.toString();

            if (invalidRefIdPattern.test(referanceId)) {
              this.excelDuplicate.push({
                rowNumber: `Row - ${i + 2}`,
                error: `Invalid referance_id at Row - ${i + 2}: "${referanceId}". Only alphanumeric characters, underscore (_) and space are allowed.`,
              });
            } else if (uniqueReferanceId.has(referanceId)) {
              this.excelDuplicate.push({
                rowNumber: `Row - ${i + 2}`,
                error: `Duplicate referance_id found: ${referanceId}`,
              });
            } else {
              uniqueReferanceId.add(referanceId);
            }
          }
        }
        //------------------------------------------------------------------------------------------------//

        // Payment Link & cc_emails bulk upload: validate payee fields and cc_emails per row
        const _ccEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const _isEsignOrBoth = this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN ||
                               this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH;
        this.convertedData.forEach((data, index) => {
          const rowNumber = index + 2;
          const hasPayeeName    = !!(data.payee_name    && data.payee_name.toString().trim());
          const hasPayeeEmail   = !!(data.payee_email   && data.payee_email.toString().trim());
          const hasPayeeContact = !!(data.payee_contact && data.payee_contact.toString().trim());
          const anyPayee = hasPayeeName || hasPayeeEmail || hasPayeeContact;
          const allPayee = hasPayeeName && hasPayeeEmail && hasPayeeContact;
          // Payee data belongs to the order row (row with referance_id); signatory continuation rows must not have it
          const isOrderRow = !!(data.referance_id && data.referance_id.toString().trim());

          if (!isOrderRow && anyPayee) {
            const rowErr = { rowNumber, error: 'Payment Link details must be in the order row (the row with referance_id), not in signatory rows.' };
            this.issueList.push(rowErr);
          }
          if (isOrderRow && anyPayee && !allPayee) {
            const rowErr = { rowNumber, error: 'Incomplete Payment Link details: Payee Name, Payee Email, and Payee Contact are all required together.' };
            this.issueList.push(rowErr);
          }
          if (isOrderRow && allPayee) {
            if (!_ccEmailPattern.test(data.payee_email.toString().trim())) {
              const rowErr = { rowNumber, error: 'Invalid Payee Email format.' };
              this.issueList.push(rowErr);
            }
            const contact = data.payee_contact.toString().trim();
            if (contact.length !== 10 || !/^\d+$/.test(contact)) {
              const rowErr = { rowNumber, error: 'Payee Contact must be exactly 10 digits.' };
              this.issueList.push(rowErr);
            }
          }

          if (_isEsignOrBoth && data.cc_emails) {
            const rawCc: string[] = data.cc_emails.toString().split(',').map((e: string) => e.trim()).filter((e: string) => !!e);
            if (rawCc.length > 10) {
              this.issueList.push({ rowNumber, error: 'cc_emails cannot have more than 10 addresses.' });
            } else {
              const invalid = rawCc.filter((e: string) => !_ccEmailPattern.test(e));
              if (invalid.length > 0) {
                this.issueList.push({ rowNumber, error: `Invalid cc_emails: ${invalid.join(', ')}` });
              }
              const unique = new Set(rawCc.map((e: string) => e.toLowerCase()));
              if (unique.size !== rawCc.length) {
                this.issueList.push({ rowNumber, error: 'cc_emails contains duplicate email addresses.' });
              }
            }
          }
        });

        if (this.convertedData.length === 0) {
          //alert('Excel file cannot be empty');
          this.messageService.add({
            severity: 'warn',
            detail: 'Excel file cannot be empty',
          });
          this.fileName = 'Selected File';
          this.isFileUpload = false;
          this.clearFile();
        }
        if (
          this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH
        ) {
          this.showbulk_esign = true;
          this.showbulk_estamp = true;
          this.getOrderObjects(this.convertedData);
        } else {
          if (
            this.serviceType ===
            CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN
          ) {
            this.showbulk_esign = true;
            this.setEsignDataForValidation(this.convertedData);
          } else if (
            this.serviceType ===
            CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
          ) {
            this.showbulk_estamp = true;
            this.getOrderObjectswithOut(this.convertedData);
          }
        }
        this.cdr.detectChanges();
        setTimeout(() => {
          const totalErrors = 
            this.issueList.length +
            this.branchCodeError.length +
            this.updateByStamp.length +
            this.excelDuplicate.length +
            this.emailDuplicate.length;
        
          if (this.convertedData.length !== 0 && totalErrors > 0 && this.isFileUpload) {
            console.log("Errors found on main screen. Triggering auto-download...");
            this.exportErrorsToExcel();
          }
        }, 600);
      };
      reader.readAsBinaryString(target.files[0]);
    }
  }

  setEsignDataForValidation(data) {
    this.validateExcelData(this.serviceType, data);
    const result: any[] = [];
    let currentArray: any[] = [];
    for (const obj of data) {
      if (obj.referance_id) {
        // Create a new array and push the current object into it
        currentArray = [obj];
        result.push(currentArray);
      } else {
        // Push the current object into the current array
        currentArray.push(obj);
      }
    }
    this.emailDuplicate = [];
    result.forEach((order, index) => {
      const emails = new Set<string>();
      const duplicates: string[] = [];

      order.forEach((user: any) => {
        const email = user.sign_email;
        if (emails.has(email)) {
          duplicates.push(email);

          const rowData = {
            ReferanceId: order[0].referance_id,
            error: `Email ${email} should not be same in single Order`,
          };
          this.emailDuplicate.push(rowData);
        }
        emails.add(email);
      });
    });

    this.setExcelDataForBulkEsign(result);
  }

  getOrderObjectswithOut(data: any) {
    this.validateExcelData(this.serviceType, data);
    const result: any[] = [];
    let currentArray: any[] = [];
    for (const obj of data) {
      // Create a new array and push the current object into it
      currentArray = [obj];
      result.push(currentArray);
    }

    this.setExcelData(result);
  }

  getOrderObjects(data: any) {
    this.validateExcelData(this.serviceType, data);
    const result: any[] = [];
    let currentArray: any[] = [];
    for (const obj of data) {
      if (obj.referance_id) {
        // Create a new array and push the current object into it
        currentArray = [obj];
        result.push(currentArray);
      } else {
        // Push the current object into the current array
        currentArray.push(obj);
      }
    }

    // Combine objects in each currentArray into a single object

    this.emailDuplicate = [];
    result.forEach((order, index) => {
      const emails = new Set<string>();
      const duplicates: string[] = [];

      order.forEach((user: any) => {
        const email = user.sign_email;
        if (emails.has(email)) {
          duplicates.push(email);

          const rowData = {
            ReferanceId: order[0].referance_id,
            error: `Email ${email} should not be same in single Order`,
          };
          this.emailDuplicate.push(rowData);
        }
        emails.add(email);
      });
    });

    this.setExcelData(result);
  }

  setExcelData(data: any) {
    var orderdetails: any = [];
    data.forEach((order, index) => {
      var template: any = [];
      var modifiedTemplate: any = [];

      const keysToExtract = this.addTemplateFields;

      template = order
        .map((obj) => {
          const extractedObj = {};
          keysToExtract.forEach((key) => {
            if (obj[key] !== undefined) {
              extractedObj[key] = obj[key];
            } else {
              extractedObj[key] = keysToExtract[key];
            }
          });

          return extractedObj;
        })
        .filter((obj) => Object.keys(obj).length > 0);
      template.forEach((value) => {
        const convertedData = Object.entries(value).map(([key, value]) => ({
          key,
          value: value !== undefined ? value : '',
        }));
        modifiedTemplate.push(convertedData);
      });
      this.templateValues = modifiedTemplate;

      const estampObject: any = [];
      let singleOrder: any = [];
      let signatoryDetailsData: any = [];
      let esignObjectData: any = {};
      const partySign: any = [];
      const withnessSign: any = [];
      let previousOrder: any;
      let esign_bill = [];
      let stamp_bill = [];
      let totalamount = 0;
      let esign_conv_fee = 0;
      let stamp_conv_fee = 0;
      let total_stamp_duty_amount = 0;

      // Payment Link & cc_emails bulk upload: extract payee/cc_emails from first row of each order
      const _parsedCcEmails = this.parseCcEmails(order[0]?.cc_emails || '');
      const _paymentData = this.buildPaymentData(order[0]);

      order.forEach((obj, index) => {
        if (
          this.serviceType != CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
        ) {
          if (
            obj.method?.trim().toUpperCase() === 'ELECTRONIC' ||
            obj.method?.trim().toUpperCase() === 'AADHAAR' ||
            obj.method?.trim().toUpperCase() === 'DSC'
          ) {
            obj.position_details = {};

            let pagesArray: string[] = [];

            if (typeof obj.pages === 'string') {
              const pages = obj.pages.toLowerCase();
              pagesArray =
                pages === 'all'
                  ? ['ALL']
                  : pages.split(',').map((page) => page.trim());
            } else if (typeof obj.pages === 'number') {
              pagesArray = [String(obj.pages)];
            }

            // Standard positions use the shared calculation (same spot and
            // size as every other flow); client-specific spots keep their
            // fixed coordinates from the tables above.
            if (isStandardSignPosition(obj.sign_position)) {
              this.positionData = getStandardSignatureRect(obj.method, obj.sign_position);
              pagesArray.forEach((page) => {
                obj.position_details[page] = [{ ...this.positionData }];
              });
            } else {
              const positionDetails =
                obj.method.trim().toUpperCase() === 'ELECTRONIC'
                  ? this.ElectronicPostionDetails
                  : this.AadhaarPostionDetails;

              positionDetails.forEach((ele) => {
                if (ele.position === obj.sign_position.toUpperCase()) {
                  this.positionData = ele.loc;
                  pagesArray.forEach((page) => {
                    obj.position_details[page] = [{ ...this.positionData }];
                  });
                }
              });
            }
          }

          if (obj.user_type) {
            if (obj.user_type.trim().toUpperCase() === 'PARTY') {
              if (obj.sign_contact_number) {
                obj.sign_contact_number = obj.sign_contact_number.toString();
              }
              const esignParty = {
                name: obj.sign_name,
                email: obj.sign_email,
                contact_number: obj.sign_contact_number,
                sign_position: obj.sign_position,
                method: obj.method.toUpperCase().trim(),
                position_details: obj.position_details,
                pages:
                  typeof obj.pages === 'string' &&
                  obj.pages.trim().toLowerCase() === 'all'
                    ? 'ALL'
                    : obj.pages,
                user_type: obj.user_type,
                esign_otp: this.otp_validation,
                send_document: true,
                send_notification: false,
                sign_method: obj.method.toUpperCase().trim(),
                schedule_timestamp: '',
                signatory_sequence: 0,
                remark: '',
                reminder: 1,
                // Payment Link & cc_emails bulk upload: cc_emails per signatory from the order's first row
                cc_emails: _parsedCcEmails,
              };
              if (esignParty.name != undefined) {
                partySign.push(esignParty);
              }
            }
          } else if (obj.user_type) {
            if (obj.user_type.trim().toUpperCase() === 'WITNESS') {
              if (obj.sign_contact_number) {
                obj.sign_contact_number = obj.sign_contact_number.toString();
              }
              const esignWitness = {
                name: obj.sign_name,
                email: obj.sign_email,
                contact_number: obj.sign_contact_number,
                sign_position: obj.sign_position,
                method: obj.method.toUpperCase().trim(),
                position_details: {},
                pages:
                  typeof obj.pages === 'string' &&
                  obj.pages.trim().toLowerCase() === 'all'
                    ? 'ALL'
                    : obj.pages,
                user_type: obj.user_type,
                esign_otp: this.otp_validation,
                send_document: true,
                send_notification: false,
                sign_method: obj.method.toUpperCase().trim(),
                schedule_timestamp: '',
                signatory_sequence: 0,
                remark: '',
                reminder: 1,
              };
              if (esignWitness.name != undefined) {
                withnessSign.push(esignWitness);
              }
            }
          }

          let details = {
            name: obj.sign_name,
            email: obj.sign_email,
            contact_number: obj.sign_contact_number,
            position_details: obj.position_details,
            sign_position: obj.sign_position,
            signatory_sequence: 0,
            send_document: true,
            send_notification: false,
            sign_method: obj.method.toUpperCase().trim(),
            schedule_timestamp: '',
            esign_otp: this.otp_validation,
          };
          let esignMethod = obj.method.trim().toUpperCase();
          if (esignMethod) {
            let esign_price =
              esignMethod === 'AADHAAR'
                ? this.aadhaarPrice
                : esignMethod === 'DSC'
                ? this.dscPrice
                : this.electronicPrice;

            let esign_bill_obj = {
              sign_method: obj.method.trim(),
              price: this.isPrepaid ? esign_price : 0,
              amount: this.isPrepaid ? esign_price : 0,
              quantity: 1,
            };
            esign_conv_fee += esign_price;
            esign_bill.push(esign_bill_obj);
          }
          if (partySign.length != 0) {
            if (
              obj.sign_position.toUpperCase() === 'CHCOMPANY' ||
              obj.sign_position.toUpperCase() === 'PNEUMATIC' ||
              obj.sign_position.toUpperCase() === 'BAILEE_1' ||
              obj.sign_position.toUpperCase() === 'ATLAS_1_ABOVE' ||
              obj.sign_position.toUpperCase() === 'ATLAS_1_BELOW' ||
              obj.sign_position.toUpperCase() === 'ATLAS_2_ABOVE' ||
              obj.sign_position.toUpperCase() === 'ATLAS_2_BELOW' ||
              obj.sign_position.toUpperCase() === 'ATLAS_3'
            ) {
              partySign[index].sign_position = 'DRAG_DROP';
              details.sign_position = 'DRAG_DROP';
            }
          }
          signatoryDetailsData.push(details);
          esignObjectData = {
            party_users: partySign,
            witness_users: withnessSign,
          };
        }

        if (obj.first_party_name != undefined) {
          obj.execution_date = this.dateEpochFormat(obj.execution_date);
        }

        const estamps = {
          first_party_name: obj.first_party_name,
          second_party_name: obj.second_party_name,
          stamp_duty_paid_by: obj.stamp_duty_paid_by,
          article_code: obj.article_code,
          stamp_duty_amount: parseInt(obj.stamp_duty_amount),
          consideration_amount: parseInt(obj.consideration_amount),
          description: obj.description,
          execution_date: obj.execution_date,
          process_type: this.selectedStampProcessType,
          first_party_pan: obj.first_party_pan,
          second_party_pan: obj.second_party_pan,
        };

        if (obj.esbtr_amount) {
          const isEsbtrProcessType = this.selectedStampProcessType === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR;
          const isEsbtrOrderType = obj.order_type?.toString().trim().toUpperCase() === 'ESBTR';

          if (!(isEsbtrProcessType && isEsbtrOrderType)) {
            estamps['esbtr_amount'] = parseInt(obj.esbtr_amount);
          }
        }

        if (estamps.stamp_duty_amount) {
          let preProcurement =
            this.selectedStampProcessType ===
            CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
          let stamp_duty_amount = preProcurement
            ? 0
            : estamps.stamp_duty_amount;
          let stamp_price = preProcurement ? 0 : this.stampPrice;
          let stamp_bill_obj = {
            article_code: estamps.article_code,
            stamp_amount: stamp_duty_amount,
            price: this.isPrepaid ? stamp_price : 0,
            amount: stamp_duty_amount + (this.isPrepaid ? stamp_price : 0),
            quantity: 1,
          };
          total_stamp_duty_amount += stamp_duty_amount;
          stamp_conv_fee += stamp_price;
          stamp_bill.push(stamp_bill_obj);
        }
        if (estamps.first_party_name != undefined) {
          estampObject.push(estamps);
        }
        if (
          this.serviceType ===
          CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
        ) {
          signatoryDetailsData = [];
        }

        singleOrder = {
          esigns: esignObjectData,
          estamps: estampObject,
          referance_id: obj.referance_id,
          branch_code: obj.branch_code,
          template_value: modifiedTemplate[0],
        };
        if (obj.account_id) {
          singleOrder.account_id = obj.account_id;
        }
        // Payment Link & cc_emails bulk upload: inject payment_data at order level
        if (_paymentData) {
          singleOrder.payment_data = _paymentData;
        }

        if (singleOrder.referance_id != undefined) {
          orderdetails.push(singleOrder);
          previousOrder = singleOrder;
        } else if (
          singleOrder.referance_id === undefined &&
          singleOrder.branch_code === undefined
        ) {
          if (previousOrder) {
            previousOrder.esigns.party_users.push(
              ...esignObjectData.party_users
            );
            previousOrder.esigns.witness_users.push(
              ...esignObjectData.witness_users
            );
          }
        }
      });
      totalamount += esign_conv_fee + stamp_conv_fee + total_stamp_duty_amount;
      let GST = (esign_conv_fee + stamp_conv_fee) * 0.18;
      let totalAmountIncTax = Math.round((totalamount + GST) * 100) / 100;
      if (this.is_wallet) {
        previousOrder.wallet_data = {
          amount: this.isPrepaid ? totalAmountIncTax : total_stamp_duty_amount,
          stamp_rate: this.stampPrice,
          esign_rate: {
            electronic: this.electronicPrice,
            dsc: this.dscPrice,
            aadhaar: this.aadhaarPrice,
          },
          stamp_bill: stamp_bill,
          esign_bill: esign_bill,
          billing: this.billingType,
          virtual_account_no: this.virtualAccountNo,
        };
      }
    });
    orderdetails.forEach((singleOrder) => {
      singleOrder.esigns.party_users = Array.from(
        new Set(singleOrder.esigns.party_users)
      );
      singleOrder.esigns.witness_users = Array.from(
        new Set(singleOrder.esigns.witness_users)
      );
    });

    if (this.templateValues.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Template Details',
        detail:
          'Template Vaules Data is not Present. Please upload with Template Values',
      });
      return;
    }

    this.placeOrderData = {
      template_id: parseInt(this.alltemplateDetails.id),
      is_bulk: true,
      file_name: this.alltemplateDetails.name,
      order_details: orderdetails,
    };
  }

  setExcelDataForBulkEsign(data: any) {
    var orderdetails: any = [];
    data.forEach((order) => {
      var template: any = [];
      var modifiedTemplate: any = [];

      //-----------------------------------Formating Template values ----------------------------//

      const keysToExtract = this.addTemplateFields;
      template = order
        .map((obj) => {
          const extractedObj = {};
          keysToExtract.forEach((key) => {
            if (obj[key] !== undefined) {
              extractedObj[key] = obj[key];
            }
          });
          return extractedObj;
        })
        .filter((obj) => Object.keys(obj).length > 0);
      template.forEach((value) => {
        const convertedData = Object.entries(value).map(([key, value]) => ({
          key,
          value,
        }));
        modifiedTemplate.push(convertedData);
      });
      this.templateValues = modifiedTemplate;
      //-------------------------------------------------------------------------------------------------------------------//
      const estampObject: any = [];
      let singleOrder: any = [];
      let signatoryDetailsData: any = [];
      let esignObjectData: any = {};
      const partySign: any = [];
      const withnessSign: any = [];
      let previousOrder: any;
      let esign_bill = [];
      let stamp_bill = [];
      let totalamount = 0;
      let esign_conv_fee = 0;

      // Payment Link & cc_emails bulk upload: extract payee/cc_emails from first row of each order
      const _parsedCcEmailsEsign = this.parseCcEmails(order[0]?.cc_emails || '');
      const _paymentDataEsign = this.buildPaymentData(order[0]);

      order.forEach((obj, index) => {
        //--------------------Formatting Esign Values--------------------//

        if (
          obj.method?.trim().toUpperCase() === 'ELECTRONIC' ||
          obj.method?.trim().toUpperCase() === 'AADHAAR' ||
          obj.method?.trim().toUpperCase() === 'DSC'
        ) {
          obj.position_details = {}; // Initialize position details object

          let pagesArray: string[] = [];

          // Convert pages to an array
          if (typeof obj.pages === 'string') {
            const pages = obj.pages.toLowerCase();
            pagesArray =
              pages === 'all'
                ? ['ALL']
                : pages.split(',').map((page) => page.trim());
          } else if (typeof obj.pages === 'number') {
            pagesArray = [String(obj.pages)];
          }

          // Standard positions use the shared calculation (same spot and size
          // as every other flow); client-specific spots keep their fixed
          // coordinates from the tables above.
          if (isStandardSignPosition(obj.sign_position)) {
            this.positionData = getStandardSignatureRect(obj.method, obj.sign_position);
            pagesArray.forEach((page) => {
              obj.position_details[page] = [{ ...this.positionData }];
            });
          } else {
            // Get the appropriate position details based on the method
            const positionDetails =
              obj.method.toUpperCase().trim().toUpperCase() === 'ELECTRONIC'
                ? this.ElectronicPostionDetails
                : this.AadhaarPostionDetails;

            // Match position and update position details
            positionDetails.forEach((ele) => {
              if (ele.position === obj.sign_position.toUpperCase()) {
                this.positionData = ele.loc;
                pagesArray.forEach((page) => {
                  obj.position_details[page] = [{ ...this.positionData }];
                });
              }
            });
          }
        }

        if (obj.user_type) {
          if (obj.user_type.toUpperCase() === 'PARTY') {
            if (obj.sign_contact_number) {
              obj.sign_contact_number = obj.sign_contact_number.toString();
            }
            const esignParty = {
              name: obj.sign_name,
              email: obj.sign_email,
              contact_number: obj.sign_contact_number,
              sign_position: obj.sign_position,
              method: obj.method.toUpperCase().trim(),
              position_details: obj.position_details,
              pages:
                typeof obj.pages === 'string' &&
                obj.pages.trim().toLowerCase() === 'all'
                  ? 'ALL'
                  : obj.pages,
              user_type: obj.user_type,
              esign_otp: this.otp_validation,
              signatory_sequence: 0,
              send_document: true,
              send_notification: false,
              schedule_timestamp: '',
              // Payment Link & cc_emails bulk upload: cc_emails per signatory from the order's first row
              cc_emails: _parsedCcEmailsEsign,
            };
            console.log('partySign', esignParty);
            if (esignParty.name != undefined) {
              partySign.push(esignParty);
            }
          }
        } else if (obj.user_type.toUpperCase() === 'WITNESS') {
          if (obj.sign_contact_number) {
            obj.sign_contact_number = obj.sign_contact_number.toString();
          }
          const esignWitness = {
            name: obj.sign_name,
            email: obj.sign_email,
            contact_number: obj.sign_contact_number,
            sign_position: obj.sign_position,
            method: obj.method.toUpperCase().trim(),
            position_details: obj.position_details,
            pages:
              typeof obj.pages === 'string' &&
              obj.pages.trim().toLowerCase() === 'all'
                ? 'ALL'
                : obj.pages,
            user_type: obj.user_type,
            signatory_sequence: 0,
            send_document: true,
            send_notification: false,
            schedule_timestamp: '',
          };
          if (esignWitness.name != undefined) {
            withnessSign.push(esignWitness);
          }
        }

        let details = {
          name: obj.sign_name,
          email: obj.sign_email,
          contact_number: obj.sign_contact_number,
          position_details: obj.position_details,
          sign_position: obj.sign_position,
          signatory_sequence: 0,
          send_document: true,
          send_notification: false,
          sign_method: obj.method.toUpperCase().trim(),
          schedule_timestamp: '',
        };

        let esignMethod = obj.method.trim().toUpperCase();
        if (esignMethod) {
          let esign_price =
            esignMethod === 'AADHAAR'
              ? this.aadhaarPrice
              : esignMethod === 'DSC'
              ? this.dscPrice
              : this.electronicPrice;

          let esign_bill_obj = {
            sign_method: obj.method.trim(),
            price: this.isPrepaid ? esign_price : 0,
            amount: this.isPrepaid ? esign_price : 0,
            quantity: 1,
          };
          esign_conv_fee += esign_price;
          esign_bill.push(esign_bill_obj);
        }

        if (partySign.length != 0) {
          //   partySign[index].position_details = details.position_details;

          if (
            obj.sign_position.toUpperCase() === 'CHCOMPANY' ||
            obj.sign_position.toUpperCase() === 'PNEUMATIC' ||
            obj.sign_position.toUpperCase() === 'BAILEE_1' ||
            obj.sign_position.toUpperCase() === 'ATLAS_1_ABOVE' ||
            obj.sign_position.toUpperCase() === 'ATLAS_1_BELOW' ||
            obj.sign_position.toUpperCase() === 'ATLAS_2_ABOVE' ||
            obj.sign_position.toUpperCase() === 'ATLAS_2_BELOW' ||
            obj.sign_position.toUpperCase() === 'ATLAS_3'
          ) {
            partySign[index].sign_position = 'DRAG_DROP';
            details.sign_position = 'DRAG_DROP';
          }
        }
        signatoryDetailsData.push(details);
        esignObjectData = {
          party_users: partySign,
          witness_users: withnessSign,
        };

        //-------------------- Creating OrderDetails ---------------------------------------//
        singleOrder = {
          esigns: esignObjectData,
          estamps: estampObject,
          referance_id: obj.referance_id,
          branch_code: obj.branch_code,
          template_value: modifiedTemplate[0],
          //signatory_details: signatoryDetailsData,
        };
        if (obj.account_id) {
          singleOrder.account_id = obj.account_id;
        }
        // Payment Link & cc_emails bulk upload: inject payment_data at order level
        if (_paymentDataEsign) {
          singleOrder.payment_data = _paymentDataEsign;
        }

        if (singleOrder.referance_id) {
          orderdetails.push(singleOrder);

          previousOrder = singleOrder; // Store the current order object as the previous order
        } else if (!singleOrder.referance_id && !singleOrder.branch_code) {
          if (previousOrder) {
            previousOrder.esigns.party_users.push(
              ...esignObjectData.party_users
            );
            previousOrder.esigns.witness_users.push(
              ...esignObjectData.witness_users
            );
          }
        }
      });
      let totalAmount = esign_conv_fee;
      let GST = esign_conv_fee * 0.18;
      let totalAmountIncTax = Math.round((totalAmount + GST) * 100) / 100;
      if (this.is_wallet && this.isPrepaid) {
        previousOrder.wallet_data = {
          amount: totalAmountIncTax,
          stamp_rate: this.stampPrice,
          esign_rate: {
            electronic: this.electronicPrice,
            dsc: this.dscPrice,
            aadhaar: this.aadhaarPrice,
          },
          stamp_bill: stamp_bill,
          esign_bill: esign_bill,
          billing: this.billingType,
          virtual_account_no: this.virtualAccountNo,
        };
      }
    });
    orderdetails.forEach((singleOrder) => {
      singleOrder.esigns.party_users = Array.from(
        new Set(singleOrder.esigns.party_users)
      );
      singleOrder.esigns.witness_users = Array.from(
        new Set(singleOrder.esigns.witness_users)
      );
    });

    if (this.templateValues.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Template Details',
        detail:
          'Template Vaules Data is not Present. Please upload with Template Values',
      });
      return;
    }

    this.placeOrderData = {
      template_id: parseInt(this.alltemplateDetails.id),
      is_bulk: true,
      file_name: this.alltemplateDetails.name,
      order_details: Array.from(new Set(orderdetails)),
    };
  }

  dateEpochFormat(excelDate) {
    if (excelDate) {
      const dateString = excelDate.toString();

      if (dateString.includes('/')) {
        const [day, month, year] = excelDate.split('/').map(Number);
        const dateObject = new Date(year, month - 1, day);
        const epochTime = dateObject.getTime();
        return epochTime;
      } else if (dateString.includes('-')) {
        const [day, month, year] = excelDate.split('-').map(Number);
        const dateObject = new Date(year, month - 1, day);
        const epochTime = dateObject.getTime();
        return epochTime;
      } else if (dateString.includes('.')) {
        const dotDatePattern = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
        if (dotDatePattern.test(dateString)) {
          const [day, month, year] = excelDate.split('.').map(Number);
          const dateObject = new Date(year, month - 1, day);
          const epochTime = dateObject.getTime();
          return epochTime;
        } else {
          excelDate = Math.floor(excelDate);
          const epochDiff = 25569;
          const date = new Date((excelDate - epochDiff) * 24 * 60 * 60 * 1000);
          this.addZeroTime(date);
          return date.getTime();
        }
      } else {
        excelDate = Math.floor(excelDate);
        const epochDiff = 25569;
        const date = new Date((excelDate - epochDiff) * 24 * 60 * 60 * 1000);
        this.addZeroTime(date);
        return date.getTime();
      }
    }
  }

  addZeroTime(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  }

  // Payment Link & cc_emails bulk upload: parse comma-separated string into a deduped array
  private parseCcEmails(raw: any): string[] {
    if (!raw) return [];
    return [...new Set<string>(raw.toString().split(',').map((e: string) => e.trim()).filter((e: string) => !!e))];
  }

  // Payment Link & cc_emails bulk upload: build payment_data if all three payee fields present
  private buildPaymentData(row: any): { payee_name: string; payee_email: string; payee_contact: string } | null {
    const name    = row?.payee_name?.toString().trim();
    const email   = row?.payee_email?.toString().trim();
    const contact = row?.payee_contact?.toString().trim();
    if (name && email && contact) {
      return { payee_name: name, payee_email: email, payee_contact: contact };
    }
    return null;
  }

  gotoOrderConfirmationPage() {
    if (
      this.totalPayableAmount > 0 &&
      this.is_wallet &&
      !this.canWalletPayment
    ) {
      return;
    }
    if (this.placeOrderData) {
      this.option = 'Complete';
      if (this.order_reviewer) {
        this.confirmOrder();
      } else {
        this.getOrderDetails(this.placeOrderData);
      }
    }
  }

  getOrderDetails(data: any) {
    this.modalService.dismissAll();
    this.catEditService.postOrder(data).subscribe({
      next: (res) => {
        if (res.status === 200) {
          if (this.order_reviewer) {
            if (res.content.bulk_id) {
              this.sendBulkExcelData(res.content.bulk_id, 'bulk');
            } else if (res.content.order_id) {
              this.sendBulkExcelData(res.content.order_id, 'order');
            }
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Order Placed!',
            detail: res.message,
          });
          setTimeout(() => {
            if (res.content.bulk_id) {
              this.router.navigate([
                '/doqfy/cat-edit/order-confirmation/bulk',
                res.content.bulk_id,
              ]);
            } else if (res.content.order_id) {
              this.router.navigate([
                'doqfy/cat-edit/order-confirmation',
                res.content.order_id,
              ]);
            }
          }, 1000);
        }
      },
      error: (err) => {
        if (
          err.status === 400 &&
          err.error?.content?.order_id &&
          err.error?.content?.referance_id
        ) {
          // Show duplicate reference modal
          this.showReferenceErrorModal(err.error.content);
        }
      },
    });
  }

  showReferenceErrorModal(content: any) {
    this.errorModalData = {
    order_id: content.order_id,
      reference_id: content.referance_id,
      errors_message_code: content.errors_message_code || [],
    };
    this.showErrorModal = true;

    // Auto download Excel after 2 seconds
    setTimeout(() => {
      this.downloadErrorExcel();
    }, 2000);
  }

  downloadErrorExcel() {
    this.excelDownloadLoading = true;

    const excelData = [
      ['Reference Number', 'Error Code', 'Error Message']
  ];

  // Add all error entries
  this.errorModalData?.errors_message_code?.forEach((errorItem: any) => {
    excelData.push([
      errorItem.reference_number || '',
      errorItem.error_code || '',
      errorItem.message || ''
    ]);
   });

    const wsData = XLSX.utils.aoa_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsData, 'Reference_Errors');

    const fileName = `Error_Detected_${
      this.errorModalData?.order_id || this.errorModalData?.reference_id || 'unknown'
    }_${new Date().getTime()}.xlsx`;
    XLSX.writeFile(wb, fileName);

    this.excelDownloadLoading = false;
  }

  closeErrorModal() {
    this.showErrorModal = false;
    this.errorModalData = null;
  }

  sendBulkExcelData(id, value) {
    let data = {
      file_name: this.fileName,
      bulk_order_id: null,
      order_id: null,
      document: this.base64File,
    };
    if (value === 'bulk') {
      data.bulk_order_id = id;
    } else {
      data.order_id = id;
    }
    this.catEditService.sendExcelDocument(data).subscribe((res) => {});
  }

  getOrderConfirmation(orderId) {
    let reqParams = {
      bulk_order_id: orderId.toString(),
      detail: 1,
    };
    this.catUploadService.getBulkOrders(reqParams).subscribe((res: any) => {
      if (res.status === 200) {
        //this.messageService.add({ severity: 'success', summary: 'Order Placed!', detail: res.message });
        this.catUploadService.orderDetails = res.content[0].order;
        this.orderDetails.getPlacedOrderDetails();
        this.onSendProductDetails();
      }
    });
  }

  validateExcelData(serviceType, excelData) {
    this.total_order = this.convertedData.length;
    this.rowsWithIssues = [];
    let errorBranchList = [];
    let branchCodeList = [];
    let branchIdList = [];
    this.total_amount = 0;
    this.totalStampAmount = 0;
    this.totalStampAmountForPopup = 0;
    this.aadhaarCount = 0;
    this.electronicCount = 0;
    this.dscCount = 0;
    this.stampCount = 0;
    this.total_order = 0;
    const validator = new ExcelDataValidator();

    for (let i = 0; i < excelData.length; i++) {
      const element = excelData[i];

      if (element.method) {
        const method = element.method.toLowerCase().trim(); // Convert to lowercase and trim whitespace

        switch (method) {
          case 'aadhaar':
            this.aadhaarCount++;
            break;
          case 'electronic':
            this.electronicCount++;
            break;
          case 'dsc':
            this.dscCount++;
            break;
          default:
            console.warn(`Unknown method: "${element.method}" at row ${i + 1}`);
        }
      }

      if (element.branch_code) {
        branchCodeList.push(element.branch_code);
      }

      if (element.referance_id) {
        this.total_order++;
      }

      this.branchCodeList = Array.from(new Set(branchCodeList));
      branchIdList = Array.from(new Set(branchIdList));
      let preProcurement =
        this.selectedStampProcessType ===
        CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
      if (element.stamp_duty_amount > 0) {
        if (element.stamp_duty_amount) {
          this.stampCount++;
        }
        this.totalStampAmount += preProcurement ? 0 : element.stamp_duty_amount;
        this.totalStampAmountForPopup += element.stamp_duty_amount;
        this.total_amount += Number(
          preProcurement ? 0 : excelData[i].stamp_duty_amount
        );
      }
    }

    const validationErrors = validator.validateExcelData(
      serviceType,
      excelData,
      this.rowsWithIssues,
      this.selectedStampProcessType ===
        CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT
    );
    validationErrors.forEach((row) => {
      if (row.error.length > 0) {
        this.issueList.push(row);
      }
    });

    // PAN validation — ESBTR only
    if (this.selectedStampProcessType === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR) {
      const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      const hasFirstPanCol  = excelData.some((row: any) => 'first_party_pan'  in row);
      const hasSecondPanCol = excelData.some((row: any) => 'second_party_pan' in row);

      if (!hasFirstPanCol) {
        this.issueList.push({ rowNumber: 'File', error: 'Column "first_party_pan" is missing. It is required for ESBTR process type.' });
      }
      if (!hasSecondPanCol) {
        this.issueList.push({ rowNumber: 'File', error: 'Column "second_party_pan" is missing. It is required for ESBTR process type.' });
      }

      excelData.forEach((row: any, index: number) => {
        const rowNumber = index + 2;
        if (hasFirstPanCol) {
          const val = row.first_party_pan?.toString().trim().toUpperCase();
          if (!val) {
            this.issueList.push({ rowNumber, error: 'first_party_pan is required for ESBTR process type.' });
          } else if (!panPattern.test(val)) {
            this.issueList.push({ rowNumber, error: `first_party_pan "${row.first_party_pan}" is invalid. Expected format: DNKPP7410P (5 letters, 4 digits, 1 letter).` });
          }
        }
        if (hasSecondPanCol) {
          const val = row.second_party_pan?.toString().trim().toUpperCase();
          if (!val) {
            this.issueList.push({ rowNumber, error: 'second_party_pan is required for ESBTR process type.' });
          } else if (!panPattern.test(val)) {
            this.issueList.push({ rowNumber, error: `second_party_pan "${row.second_party_pan}" is invalid. Expected format: DNKPP7410P (5 letters, 4 digits, 1 letter).` });
          }
        }
      });
    }

    this.stampValidation.forEach((stampItem) => {
      this.issueList.forEach((issueItem) => {
        if (stampItem.rowNumber === issueItem.rowNumber) {
          issueItem.error = issueItem.error
            .replace(
              'Execution Date should  be in Formet (DD-MM-YYYY) and not be greater than the current date.',
              ''
            )
            .trim();
        }
      });
    });
    //************ */ Temparary fix for multi esign  need to add mentod to remove the error validation for the ------------------------------------------------------------------///
    this.issueList.forEach((issueItem) => {
      issueItem.error = issueItem.error
        .replace(
          'Invalid or missing Referance ID. Invalid or missing Branch ID. Invalid or missing First Party Name. Invalid or missing Second Party Name. Invalid or missing Stamp Duty Paid By.Invalid or missing Stamp Duty Amount. Invalid or missing Description. Invalid or missing Article ID. Invalid or missing Consideration Amount. Invalid or missing Execution Date.',
          ''
        )
        .trim();
    });
    if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN ||
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH
    ) {
      this.issueList.forEach((issueItem) => {
        issueItem.error = issueItem.error
          .replace(
            'Invalid or missing Referance ID. Invalid or missing Branch ID.',
            ''
          )
          .trim();
        issueItem.error = issueItem.error
          .replace(
            'Invalid or missing First Party Name. Invalid or missing Second Party Name. Invalid or missing Stamp Duty Paid By.Invalid or missing Stamp Duty Amount. Invalid or missing Description. Invalid or missing Article ID. Invalid or missing Consideration Amount.',
            ''
          )
          .trim();
      });
    }

    //****************************************************************************************************************************//
    this.issueList.forEach((item) => {
      if (item.error === '') {
        this.rowNumberIssue.push(item.referance_id);
      }
    });

    this.rowNumberIssue = Array.from(new Set(this.rowNumberIssue));

    this.rowNumberIssue.forEach((element) => {
      this.rowsWithIssues.forEach((ele) => {
        if (ele.referance_id === element) {
          this.rowstoDisplay.push(ele);
        }
      });
    });

    this.rowsWithIssues = this.rowsWithIssues.filter((row) => {
      return !this.rowstoDisplay.find(
        (id) => id.referance_id === row.referance_id
      );
    });

    this.rowsWithIssues = Array.from(new Set(this.rowsWithIssues));
    this.issueList = this.issueList.filter((issueItem) => {
      return issueItem.error !== '';
    });

    this.errorBracnhList = Array.from(new Set(errorBranchList));

    this.errorBracnhList = this.errorBracnhList.filter(
      (branchId) => !branchIdList.includes(branchId)
    );
    this.rowsWithIssues = Array.from(new Set(this.rowsWithIssues));
  }

  clearFile() {
    this.selectedFile = '';
    const inputElement = <HTMLInputElement>(
      document.getElementById('upload_file')
    );
    inputElement.value = null;
  }

  viewIssues(content) {
    this.rowsWithIssues = Array.from(new Set(this.rowsWithIssues));
    this.modalService
      .open(content, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
      })
      .result.then(
        (result) => {},
        (reason) => {}
      );
    //  setTimeout(() => {
    //   this.exportErrorsToExcel();
    // }, 2000);
  }

  exportErrorsToExcel() {
    const errorMap = new Map<string, string[]>();
    const collectErrors = (sourceArray: any[]) => {
      if (sourceArray && sourceArray.length > 0) {
        sourceArray.forEach((item) => {
        let refNumber = 'N/A';
        // 1. Extract numeric ID to find Reference Number in convertedData
        let numericRow: number | null = null;
        if (typeof item.rowNumber === 'string') {
          const match = item.rowNumber.match(/\d+/);
          numericRow = match ? parseInt(match[0], 10) : null;
        } else if (typeof item.rowNumber === 'number') {
          numericRow = item.rowNumber;
        }
        if (numericRow && this.convertedData[numericRow - 2]) {
          const dataRow = this.convertedData[numericRow - 2];
          refNumber = dataRow.referance_id || dataRow.reference_id || 'N/A';
        } else if (item.ReferanceId) {
          refNumber = item.ReferanceId;
        }
        // 2. Take only the raw error message (no "Row X" prefix)
        const cleanError = item.error || 'Unknown error';
        // 3. Group messages by Reference Number
        if (!errorMap.has(refNumber)) {
          errorMap.set(refNumber, []);
        }
        // Prevent adding the exact same error message twice for one reference
        if (!errorMap.get(refNumber)?.includes(cleanError)) {
          errorMap.get(refNumber)?.push(cleanError);
        }
        });
      }
    };

    collectErrors(this.issueList);
    collectErrors(this.updateByStamp);
    collectErrors(this.branchCodeError);
    collectErrors(this.excelDuplicate);
    collectErrors(this.emailDuplicate);

     if (errorMap.size === 0) return;

     // 4. Transform Map into Excel rows (One row per Reference Number)
     const dataToExport = Array.from(errorMap.entries()).map(([ref, messages]) => ({
       'Reference Number': ref,
       'Error Message': messages.join('; ') // Combined messages separated by semicolon
     }));

    // 5. Generate Excel
   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
  
    // Set column widths
    ws['!cols'] = [{ wch: 25 }, { wch: 90 }];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Issues');
    XLSX.writeFile(wb, 'Error_Log.xlsx');
  }
  //-----------------------------------------Reviewer Email--------------------------------------//

  confirmOrder() {
    this.confirmationService.confirm({
      message: 'Do you want get your request Reviewed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-circle',
      accept: () => {
        this.getOrderDetails(this.placeOrderData);
      },
      acceptLabel: 'No , Proceed to Place Order',
      acceptIcon: 'pi pi',
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.onApproveMethod();
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      },
      rejectLabel: 'Yes',
      rejectIcon: 'pi pi',
    });
  }

  onApproveMethod() {
    this.reviewDetails.reset();
    this.getUserDetails();
    this.addNewDetails();

    this.modalService
      .open(this.reviewOrder, {
        // Use this.reviewOrder directly
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }
  closeModel() {
    this.modalService.dismissAll();
    this.reviewDetails.reset();
  }

  removeDetails(index: number) {
    this.reviewEmailArray().removeAt(index);
    this.reviewDetails.value.reviewer.splice(index, 1);
  }

  reviewEmailArray(): FormArray {
    return this.reviewDetails.get('reviewEmail') as FormArray;
  }

  addNewDetails() {
    this.reviewEmailArray().push(this.initDetails());
  }

  initDetails() {
    return this.formBuilder.group({
      email: new FormControl(null, [Validators.email]),
    });
  }
  goBack() {
    this.closeModel();
  }

  placeOrderWithReview() {
    this.submitted = true;

    const reviewEmail = [];
    this.reviewDetails.value.reviewEmail.forEach((element) => {
      if (element.email) {
        reviewEmail.push(element.email);
      }
    });
    this.getEmailValid(reviewEmail);
  }

  getEmailValid(reviewEmail) {
    const data = { order_reviewers: reviewEmail };
    this.orderService.verifyApproverEmail(data).subscribe((res) => {
      this.validEmail = res['content'];
      if (this.validEmail.validated) {
        if (reviewEmail.length === 0) {
          this.messageService.add({
            severity: 'warn',
            detail: 'Please add atleast one Reviewer to Proceed',
          });
        } else {
          this.setReviewData(reviewEmail);
        }
      } else {
        this.messageService.add({
          severity: 'warn',
          detail: 'Please enter valid  Email for Reviewer',
        });
      }
    });
  }

  setReviewData(reviewEmail) {
    this.placeOrderData.order_details.forEach((element) => {
      element.order_reviewers = reviewEmail;
    });

    this.getOrderDetails(this.placeOrderData);
  }

  getUserDetails() {
    const account_id = this.storageService.getAccountId();
    this.orderService.getApproverEmail(account_id).subscribe((res) => {
      if (res.content.length != 0) {
        this.userData = res['content'];
      }
    });
  }

  selectReviewer() {
    this.selectedReviewer = this.reviewDetails.value.reviewer;
    this.reviewEmailArray().clear();
    this.selectedReviewer.forEach((element, index) => {
      this.addNewDetails();
      this.reviewEmailArray().at(index).get('email').setValue(element.email);
    });

    if (this.selectedReviewer.length === 0) {
      this.addNewDetails();
    }
  }

  calculateOrderPrice() {
    let preProcurement =
      this.selectedStampProcessType ===
      CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
    let stampPrice = preProcurement ? 0 : this.stampPrice;
    let totalAadhaarPrice =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.aadhaarCount * this.aadhaarPrice
        : 0;
    let totalElectronicPrice =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.electronicCount * this.electronicPrice
        : 0;
    let totalDscPrice =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.dscCount * this.dscPrice
        : 0;
    let totalSignConvFee =
      totalAadhaarPrice + totalElectronicPrice + totalDscPrice;
    let totalStampConvFee =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.stampCount * stampPrice
        : 0;

    let totalConvFee = totalSignConvFee + totalStampConvFee;

    this.totalConvFee = Math.round(totalConvFee * 100) / 100;
    let GSTOntotalBill = totalConvFee * 0.18;
    this.GSTOnTotalBill = Math.round(GSTOntotalBill * 100) / 100;
    this.totalStampAmount = Math.round(this.totalStampAmount * 100) / 100;
    this.totalPayableAmount =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.totalStampAmount + this.totalConvFee + this.GSTOnTotalBill
        : this.totalStampAmount;
    this.totalPayableAmount = Math.round(this.totalPayableAmount * 100) / 100;
    if (this.walletBalance > this.totalPayableAmount) {
      this.canWalletPayment = true;
    } else {
      this.canWalletPayment = false;
    }
  }

  closePaymentModal(): void {
    this.closePaymentPopupBtn.nativeElement.click();
  }
  // Add these methods to handle drag and drop functionality
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      // Create a mock event object that matches the structure expected by onFileChange
      const mockEvent = {
        target: {
          files: files,
        },
      };

      // Call the existing onFileChange method with the dropped files
      this.onFileChange(mockEvent);
    }
  }

  getRealWalletBalance(virtual_account_no: any) {
    this.walletService.getWalletClientDetails(virtual_account_no).subscribe(
      (data: any) => {
        this.walletBalance = data.content.current_balance;
        this.storageService.setWalletBalance(data.content.current_balance);
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading transactions:', error);
      }
    );
  }

  getDummyWalletBalance(account_id: any) {
    this.orderService.getBalance(account_id).subscribe(
      (data: any) => {
        this.walletBalance = data.content.current_balance;
        this.storageService.setWalletBalance(data.content.current_balance);
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading transactions:', error);
      }
    );
  }

  onStampProcessTypeChange(event: any) {
    this.selectedStampProcessType = event.value;
    this.removeFileName();
    this.storageService.updateStampProcessType(event.value);
    console.log('Selected stamp process type:', event.value);

    if (this.selectedStampProcessType !== '') {
      this.showUploadButton = true;
    }
  }

  validateStampDenominationFromBackend(excelData: any[]) {
    const groupedData = this.stampDenominationService.groupStampDenomination(
      excelData,
      { includeAccountId: false }
    );

    const payload =
      this.stampDenominationService.mapToStampDenominationRequest(groupedData);

    this.estampService.getStampInventoryAndDenominationInfo(payload).subscribe({
      next: (response) => {
        this.stampDenominationService.handleStampDenominationErrors(
          response,
          groupedData,
          this.convertedData,
          this.issueList,
          this.rowsWithIssues,
          false
        );

        this.issueList = [...this.issueList];
        this.rowsWithIssues = [...this.rowsWithIssues];

        if (this.issueList.length > 0) {
          this.clearFile();
          this.fileApproved = false;
        } else {
          this.fileApproved = true;
        }
      },
      error: (err) => {
        console.error('Stamp denomination validation failed', err);
        this.fileApproved = false;
      },
    });
  }
        onColumnCheckboxChange(event: any, header: string) {
  if (event.target.checked) {
    if (!this.selectedColumns.includes(header)) {
      this.selectedColumns.push(header);
    }
  } else {
    this.selectedColumns = this.selectedColumns.filter(col => col !== header);
  }
}
sendCsvToBackend() {
  const payload = {
    file_name: this.fileName,
    file_content: this.base64File,
    columns: this.selectedColumns
  };

  this.userDashboardService.convertCsvFile(payload).subscribe({
    next: (res: any) => {

      console.log('Upload Success:', res);

      const fileName = res.content.file_name;
      const base64 = res.content.file_content;

      // Base64 decode
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      // xlsx file type
      const blob = new Blob(
        [byteArray],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);


      this.selectedColumns = [];

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'File converted and downloaded successfully'
      });
    },

    error: (err) => {

      err.alreadyHandled = true;

      this.messageService.add({
        severity: 'error',
        summary: 'Upload Failed',
        detail: err?.error?.detail || 'Server error'
      });
    }
  });
}
}